// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/audit-logs",
  Detail: "/pyr/audit-logs/{id}",
};
